import { cn } from "@nexus/ui";
import { AskNexusMark } from "@/features/ask-nexus/components/AskNexusMark";

/** The prototype's working line: the live mark and shimmering text. Shown only while work continues. */
export function AskNexusWorking({ text, className }: { text: string; className?: string }) {
  return (
    <p className={cn("inline-flex items-center gap-2 text-[13px] text-(--an-ink-2)", className)} role="status">
      <AskNexusMark isLive className="h-4 w-[30px] flex-none" />
      <span className="ask-nexus-shimmer">{text}</span>
    </p>
  );
}
